import { createReducer, on } from '@ngrx/store';

import * as fromRootImpeActions from '@apps/root/store/impersonate/impe.actions';
import * as fromAuthLoginActions from '@apps/auth/store/login/login.actions';
import * as fromAuthProfileActions from '@apps/auth/store/profile/profile.actions';

import * as fromActions from './entities-selection.actions';
import { BackEntitiesSelectionInitialState, entitiesSelectionAdapter, EntitiesSelectionValue } from './entities-selection.state';

export const BackEntitiesSelectionReducer = createReducer(
    BackEntitiesSelectionInitialState,
    on(
        fromRootImpeActions.RootImpersonateSet,
        fromRootImpeActions.RootImpersonateUnset,
        fromAuthProfileActions.AuthProfileApplicationRolesSet,
        fromAuthProfileActions.AuthProfileApplicationRolesReset,
        fromAuthLoginActions.AuthLogout,
        fromActions.BackEntitiesSelectionResetRequested,
        () => BackEntitiesSelectionInitialState
    ),
    on(
        fromActions.BackEntitiesSelectionChanged,
        (state, { key, all, entityIds }) => ({
            ...state,
            selections: entitiesSelectionAdapter.upsertOne(
                new EntitiesSelectionValue(key, all, all ? [] : entityIds),
                state.selections
            )
        })
    )
);
